import MsInput from './MsInput.vue';

MsInput.install = Vue => Vue.component(MsInput.name, MsInput);

export default MsInput;
